export default {
  state: {
    showFooter: false
  },
  mutations: {
    setShowFooter (state, payload) {
      state.showFooter = payload
    }
  },
  actions: {
    toggleFooter ({ commit }, payload) {
      commit('setShowFooter', payload)
    }
  },
  getters: {
    isFooterShown (state) {
      return state.showFooter
    }
  }
}
